module.exports = "/assets/data/8d09d04bc95ca729c3de804d4df09cf5-NW4.data.json";